import { createSelector } from "reselect";
import getLocationMetadata from "../base_getters/get_location_metadata";

const getIsSuperadminPage = createSelector([
  getLocationMetadata
], (locationMetadata) => locationMetadata.isSuperadmin || false);

export default getIsSuperadminPage;